import { Link } from "react-router-dom";

function PageMissing() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100">
      <h1 className="display-2">Leider konnte deine Seite nicht gefunden werden</h1>

      <div className="mt-large">
        <div className="links">
          <Link className="btn btn-large btn-secondary" to="/">
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PageMissing;
